import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Lock, User, Loader2 } from 'lucide-react';
import { adminLogin, setToken, getToken } from '@/lib/api';
import { BrandLogo } from '@/components/BrandLogo';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (getToken()) navigate('/admin/dashboard'); }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(username, password);
      setToken(res.access_token);
      toast.success('Welcome back');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='relative flex min-h-screen items-center justify-center overflow-hidden bg-[#20272A] px-5'>
      <img src='/media/img/quarry-dusk.jpg' alt='' className='absolute inset-0 h-full w-full object-cover opacity-25' />
      <div className='absolute inset-0' style={{ background: 'linear-gradient(180deg, rgba(7,91,97,0.55), rgba(32,39,42,0.95))' }} />
      <div className='relative w-full max-w-md'>
        <div className='mb-8 flex justify-center'><BrandLogo height={46} /></div>
        <form onSubmit={submit} className='rounded-2xl border border-white/10 bg-[#20272A]/80 p-8 backdrop-blur-md' data-testid='admin-login-form'>
          <span className='eyebrow text-[#B88A3B]'>Admin Console</span>
          <h1 className='mt-2 font-head text-2xl font-semibold text-[#F6F5F1]'>Content Management</h1>
          <p className='mt-1 text-sm text-[#F6F5F1]/50'>Sign in to manage the website content.</p>

          <div className='mt-7 space-y-4'>
            <div>
              <label className='text-xs text-[#F6F5F1]/60'>Username</label>
              <div className='mt-1.5 flex items-center gap-2 rounded-xl border border-white/12 bg-white/5 px-3'>
                <User size={16} className='text-[#F6F5F1]/40' />
                <input value={username} onChange={(e) => setUsername(e.target.value)} className='h-11 flex-1 bg-transparent text-sm text-[#F6F5F1] outline-none placeholder:text-[#F6F5F1]/30' placeholder='admin' data-testid='admin-username' />
              </div>
            </div>
            <div>
              <label className='text-xs text-[#F6F5F1]/60'>Password</label>
              <div className='mt-1.5 flex items-center gap-2 rounded-xl border border-white/12 bg-white/5 px-3'>
                <Lock size={16} className='text-[#F6F5F1]/40' />
                <input type='password' value={password} onChange={(e) => setPassword(e.target.value)} className='h-11 flex-1 bg-transparent text-sm text-[#F6F5F1] outline-none placeholder:text-[#F6F5F1]/30' placeholder='••••••••' data-testid='admin-password' />
              </div>
            </div>
          </div>

          <button type='submit' disabled={loading} className='mt-7 inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[#B88A3B] text-sm font-medium text-[#20272A] transition-colors hover:bg-[#c99a48] disabled:opacity-60' data-testid='admin-login-button'>
            {loading ? <Loader2 size={17} className='animate-spin' /> : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
